import styles from "./compare-dropdown.module.css";

import { inject, observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { ClientDashboardStore } from "../../../store/store";
import { MenuItem, Select } from "@mui/material";

export interface CompareDropdownProps {
    clientDashboardStore?: ClientDashboardStore;
    onChange(value: number): void;
}

function CompareDropdown(props: CompareDropdownProps) {
    const { onChange } = props;

    const { t } = useTranslation("dashboard");

    const handleChange = (event: any) => {
        onChange(event.target.value);
    };

    const render = () => {
        return (
            <div className={styles["container"]}>
                <Select
                    sx={{
                        ".MuiOutlinedInput-notchedOutline": {
                            border: "1px solid rgba(23, 53, 68, 0.60)",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            border: "1px solid rgba(23, 53, 68, 1)",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            border: "1px solid rgba(23, 53, 68, 1)",
                        },
                        textTransform: "uppercase",
                    }}
                    defaultValue={1}
                    onChange={handleChange}
                >
                    <MenuItem value={1}>{"7 " + t("DaysAgo")}</MenuItem>
                    <MenuItem value={2}>{"14 " + t("DaysAgo")}</MenuItem>
                    <MenuItem value={3}>{"21 " + t("DaysAgo")}</MenuItem>
                    <MenuItem value={4}>{"28 " + t("DaysAgo")}</MenuItem>
                </Select>
            </div>
        );
    };

    return render();
}

export default inject("clientDashboardStore")(observer(CompareDropdown));
